import { render, staticRenderFns } from "./NotAllowedView.vue?vue&type=template&id=71626114&scoped=true"
import script from "./NotAllowedView.vue?vue&type=script&lang=js"
export * from "./NotAllowedView.vue?vue&type=script&lang=js"
import style0 from "./NotAllowedView.vue?vue&type=style&index=0&id=71626114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71626114",
  null
  
)

export default component.exports